
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { DataTableHeader } from 'vuetify';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import paginacion from './lista-listado-paginacion.vue';
import { Pago } from '@/__env/lib/Ventas/Pagos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            paginacion
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }

        public get Headers(): Array<DataTableHeader>
        {
            if ( this.Controlador.Vista.Modo == 'comision' )
            {

           return [
                    { text: 'Id', align: 'center', value: 'Col1', },
                    { text: 'Cliente', align: 'start', value: 'Col3' },
                    { text: 'Estado', align: 'center', value: 'Col4' },
                    { text: 'Tipo', align: 'center', value: 'Col5' },
                    { text: 'Importe', align: 'end', value: 'Col7' },
                    { text: 'Comisión', align: 'center', value: 'Com1' },
                    { text: 'Financiación', align: 'center', value: 'Com2' },
                    { text: 'Codigo cuotas', align: 'center', value: 'Com3' },
                    { text: 'Cargo por envío', align: 'center', value: 'Com4' },
                    { text: 'Cuenta', align: 'center', value: 'Col8' },
                    { text: '', align: 'end', value: 'Col10' },
                ];

            }
            else if ( this.Controlador.Vista.Modo == 'envio' )
            {
                return [
                    { text: 'Id', align: 'center', value: 'Col1', },
                    { text: 'Pedidos', align: 'center', value: 'Col2', },
                    { text: 'Cliente', align: 'start', value: 'Col3' },
                    { text: 'Metodo', align: 'start', value: 'Det1' },
                    { text: 'Estado', align: 'center', value: 'Col4' },
                    { text: 'Tipo', align: 'center', value: 'Col5' },
                    { text: 'Metodo', align: 'center', value: 'Col6' },
                    { text: 'Importe', align: 'end', value: 'Col7' },
                    { text: 'Cuenta', align: 'center', value: 'Col8' },
                    { text: 'Fecha', align: 'center', value: 'Col9' },
                    { text: '', align: 'end', value: 'Col10' },
                ];

            } else
            {
                return [
                    { text: 'Id', align: 'center', value: 'Col1', },
                    { text: 'Pedidos', align: 'center', value: 'Col2', },
                    { text: 'Cliente', align: 'start', value: 'Col3' },
                    { text: 'Detalle', align: 'start', value: 'Det1' },
                    { text: 'Estado', align: 'center', value: 'Col4' },
                    { text: 'Tipo', align: 'center', value: 'Col5' },
                    { text: 'Metodo', align: 'center', value: 'Col6' },
                    { text: 'Importe', align: 'end', value: 'Col7' },
                    { text: 'Cuenta', align: 'center', value: 'Col8' },
                    { text: 'Fecha', align: 'center', value: 'Col9' },
                    { text: '', align: 'end', value: 'Col10' },
                ];
            }
        }

        public CargandoMenu: boolean = false;
        public Opciones = [

            { Tipo: 'titulo', Titulo: 'Acciones' },
            {
                Tipo: 'opcion', Titulo: 'Agregar al pedido', Accion: async ( item: Pago ) =>
                {

                    this.Controlador.Seleccionados = [item];

                },
                Ok: ( item: Pago ) => !item.Propio && !item.Pedidos.hasRows()
            },

        ];


        AbrirPedido( item: number )
        {
            this.Controlador.AbrirPedido( item );
        }
    }
